import React, { useState } from "react";
import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";

const ContentBody = (props) => {
  const { verificationList, pageNumber, dataPerPage, pageCount } = props;
  const requests = verificationList.data || [];
  const changePage = ({ selected }) => {
    props.onChangePageNumber(selected);
  };
  const [sortBy, setSortBy] = useState("createDate");
  const [sortType, setSortType] = useState(true);
  const sortClick = (key) => {
    props.onChangeSortClick(key);
    setSortBy(key);
    if (sortType) {
      setSortType(false);
    } else {
      setSortType(true);
    }
    props.onChangeSortType(sortType);
  };
  let count = pageNumber + 1;
  if (count > 1) {
    count = dataPerPage * pageNumber + 1;
  }

  const handleSearch = async (e) => {
    props.onSearchChang(e.target.value);
  };

  const setSelectedOption = (e) => {
    props.onPerPageChange(e.target.value);
  };

  const updateRequestStatus = async (e, id, userId) => {
    let obj = {
      status: e,
      _id: id,
      userId: userId,
    };
    let text = "";
    let button = "";
    if (e === 1) {
      text = "Are You sure you want to pending this request!";
      button = "Yes";
    } else if (e === 2) {
      text = "Are You sure you want to put on hold this request!";
      button = "Yes";
    } else if (e === 3) {
      text = "Are You sure you want to approve this request!";
      button = "Yes";
    } else if (e === 4) {
      text = "Are You sure you want to reject this request!";
      button = "Yes";
    }
    Swal.fire({
      title: "Are you sure?",
      text: text,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: button,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(
            process.env.REACT_APP_API_URL + "request-update",
            {
              method: "POST",
              body: JSON.stringify(obj),
              headers: {
                "Content-type": "application/json",
              },
            }
          );
          const result = await response.json();
          if (result.status === true) {
            // refresh listing to update data
          } else {
            // error message
          }
        } catch (error) {
          console.log(error);
        }
      }
    });
  };

  const requestsData = requests.map((val, i) => {
    return (
      <React.Fragment key={Math.random(1, 9999)}>
        <tr>
          <td>#{val.requestId}</td>
          <td className="wspace-no">{val.createDate}</td>
          <td className="wspace-no">
            <span className="fs-16">
              <div className="row">
                <div className="col-lg-2 col-md-2">
                  <img
                    src={
                      process.env.REACT_APP_IMAGE_URL +
                      "profile-images/thumbnail_96/" +
                      val.profile
                    }
                    width={75}
                    height={75}
                    alt={val.name}
                  />
                </div>
                <div className="col-lg-4 col-md-4">
                  {val.name}
                  <br />
                  {val.username}
                  <br />
                  {val.email}
                </div>
              </div>
            </span>
          </td>
          <td className="wspace-no">
            <span className="text-secoundry fs-14 font-w600">
              Social: {val.socialLinks} <br />
              Links: {val.otherLinks}
            </span>
          </td>
          <td>
            {val.verification_status === 1 && (
              <span className="btn btn-warning light text-warning border-light btn-sm">
                Pending
              </span>
            )}
            {val.verification_status === 2 && (
              <span className="btn bgl-secoundry light text-secoundry border-light btn-sm">
                ON HOLD
              </span>
            )}
            {val.verification_status === 3 && (
              <span className="btn bgl-success light text-success btn-sm btn-rounded">
                Verified
              </span>
            )}
            {val.verification_status === 4 && (
              <span className="btn btn-danger light text-danger btn-sm btn-rounded">
                Rejected
              </span>
            )}
          </td>
          <td>
            <div className="dropdown text-end">
              <div>
                <a
                  className="btn btn-success btn-sm"
                  href={"/admin/request/" + val._id}
                >
                  <i className="fas fa-eye" />
                </a>
              </div>
              {val.verification_status !== 4 && (
                <React.Fragment>
                  <div className="btn-link" data-bs-toggle="dropdown">
                    <svg
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.0005 12C11.0005 12.5523 11.4482 13 12.0005 13C12.5528 13 13.0005 12.5523 13.0005 12C13.0005 11.4477 12.5528 11 12.0005 11C11.4482 11 11.0005 11.4477 11.0005 12Z"
                        stroke="#3E4954"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M18.0005 12C18.0005 12.5523 18.4482 13 19.0005 13C19.5528 13 20.0005 12.5523 20.0005 12C20.0005 11.4477 19.5528 11 19.0005 11C18.4482 11 18.0005 11.4477 18.0005 12Z"
                        stroke="#3E4954"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M4.00049 12C4.00049 12.5523 4.4482 13 5.00049 13C5.55277 13 6.00049 12.5523 6.00049 12C6.00049 11.4477 5.55277 11 5.00049 11C4.4482 11 4.00049 11.4477 4.00049 12Z"
                        stroke="#3E4954"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </div>
                  <div className="dropdown-menu dropdown-menu-right">
                    {(val.verification_status === 1 ||
                      val.verification_status === 2) && (
                      <React.Fragment>
                        <button
                          className="dropdown-item text-black"
                          onClick={() =>
                            updateRequestStatus(3, val._id, val.userId)
                          }
                        >
                          <i className="far fa-check-circle me-1 text-success" />
                          Verify
                        </button>
                        <button
                          className="dropdown-item text-black"
                          onClick={() =>
                            updateRequestStatus(2, val._id, val.userId)
                          }
                        >
                          <i className="fas fa-cancel me-1 text-danger" />
                          On-Hold
                        </button>
                        <button
                          className="dropdown-item text-black"
                          onClick={() =>
                            updateRequestStatus(4, val._id, val.userId)
                          }
                        >
                          <i className="far fa-times-circle me-1 text-danger" />
                          Reject
                        </button>
                      </React.Fragment>
                    )}
                    {val.verification_status === 3 && (
                      <button
                        className="dropdown-item text-black"
                        onClick={() =>
                          updateRequestStatus(1, val._id, val.userId)
                        }
                      >
                        <i className="fas fa-clock me-1 text-warning" />
                        Pending
                      </button>
                    )}
                  </div>
                </React.Fragment>
              )}
            </div>
          </td>
        </tr>
      </React.Fragment>
    );
  });

  const showingEntries = () => {
    let testTotal = pageNumber + 1;
    let startnumber = (testTotal - 1) * dataPerPage + 1;
    let endnumber =
      testTotal * dataPerPage > testTotal - 1 * dataPerPage
        ? testTotal * 1 * dataPerPage
        : testTotal * dataPerPage;
    if (endnumber > verificationList.totalUsers) {
      endnumber = verificationList.totalUsers;
    }
    return (
      "Showing " +
      startnumber +
      " to " +
      endnumber +
      " of " +
      verificationList.totalUsers +
      " records"
    );
  };

  const statusChangeHandler = (e) => {
    props.onChangeStatus(e);
  };

  return (
    <React.Fragment>
      <div className="content-body">
        <div className="container-fluid">
          <div className="d-sm-flex d-block justify-content-between align-items-center mb-4">
            <div className="card-action coin-tabs mt-3 mt-sm-0">
              <ul className="nav nav-tabs" role="tablist">
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    data-bs-toggle="tab"
                    href="#All"
                    onClick={() => statusChangeHandler(null)}
                  >
                    All Status
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link "
                    data-bs-toggle="tab"
                    href="#Pending"
                    onClick={() => statusChangeHandler(1)}
                  >
                    Pending
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-bs-toggle="tab"
                    href="#Approved"
                    onClick={() => statusChangeHandler(3)}
                  >
                    Verified
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-bs-toggle="tab"
                    href="#on-hold"
                    onClick={() => statusChangeHandler(2)}
                  >
                    On-Hold
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-bs-toggle="tab"
                    href="#Rejected"
                    onClick={() => statusChangeHandler(4)}
                  >
                    Rejected
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="tab-content">
                <div className="tab-pane fade show active" id="AllStatus">
                  <div className="table-responsive">
                    <div
                      id="example_wrapper"
                      className="dataTables_wrapper d-flex justify-content-between"
                    >
                      <div className="dataTables_length" id="example_length">
                        <label>
                          Show
                          <select
                            name="example_length"
                            aria-controls="example"
                            onChange={setSelectedOption}
                          >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </select>
                          entries
                        </label>
                      </div>
                      <div className="d-flex justify-content-end">
                        <div
                          id="example_filter"
                          className="dataTables_filter mx-4"
                        >
                          <input
                            type="search"
                            className="form-control"
                            aria-controls="example"
                            placeholder="Search..."
                            onKeyDown={(e) =>
                              e.key === "Enter" && handleSearch(e)
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <table
                      className="table display mb-4 dataTablesCard order-table card-table text-black"
                      id="application-tbl1"
                    >
                      <thead>
                        <tr>
                          <th
                            onClick={() => {
                              sortClick("requestId");
                            }}
                          >
                            Request ID
                            {sortBy === "requestId" && sortType === true ? (
                              <IoIosArrowDropdown />
                            ) : null}
                            {sortBy === "requestId" && sortType === false ? (
                              <IoIosArrowDropup />
                            ) : null}
                          </th>
                          <th
                            onClick={() => {
                              sortClick("createDate");
                            }}
                          >
                            Date Applied
                            {sortBy === "createDate" && sortType === true ? (
                              <IoIosArrowDropdown />
                            ) : null}
                            {sortBy === "createDate" && sortType === false ? (
                              <IoIosArrowDropup />
                            ) : null}
                          </th>
                          <th
                            onClick={() => {
                              sortClick("name");
                            }}
                          >
                            User Details
                            {sortBy === "name" && sortType === true ? (
                              <IoIosArrowDropdown />
                            ) : null}
                            {sortBy === "name" && sortType === false ? (
                              <IoIosArrowDropup />
                            ) : null}
                          </th>
                          <th>Links</th>
                          <th>Status</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {requests.length > 0 && requestsData}
                        {requests.length === 0 && (
                          <tr>
                            <td colSpan="6">
                              <div className="text-center">
                                <h4>Sorry!</h4>
                                <h5>No Verification Requests Found.</h5>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-12">
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <div className="sm-mb-0 mb-3">
                  <h5>{showingEntries()}</h5>
                </div>
                <ReactPaginate
                  previousLabel="Previous"
                  nextLabel="Next"
                  pageCount={pageCount}
                  onPageChange={changePage}
                  containerClassName="pagination pagination-circle"
                  previousClassName="page-item page-indicator"
                  previousLinkClassName="page-link"
                  nextClassName="page-item page-indicator"
                  nextLinkClassName="page-link"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  disabledClassName="disabled"
                  activeClassName="active"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ContentBody;
